import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { getControlSheetAdvance } from "../../redux/actions/controlSheet.action"
import { getDefaultCompany } from "../../redux/actions/defaultCompany";
import { getAllCompany } from "../../redux/actions/companyAccess";
import PageHeader from "../../components/PageHeader/PageHeader";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { sendOrderPaymentDuePTEmail } from "../../redux/actions/email.action";
import { TabTitle } from "../../utils/GeneralFunction";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import { MailOutlined } from '@ant-design/icons';
import { Button, notification, Table } from "antd";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import numeral from "numeral";
import moment from "moment";
import "./pickticket.css";
import filterHelper from "../../utils/filterHelper";
import { currencySymbol } from "../../utils/constants";

const ControlSheetAdvanceShip = ({ token, userRights }) => {
  TabTitle("Control Sheet Advanceship")
  const [minimize, setMinimize] = useState(false);
  const menuId = userRights.col_menu_id;
  const dispatch = useDispatch();
  const [controlSheet, setControlSheet] = useState([]);
  const [spinner, setSpinner] = useState(true);
  const [loadings, setLoadings] = useState([]);
  const tableRef = useRef(null);

  useEffect(() => {
    dispatch(getAllCompany(token));
    dispatch(getDefaultCompany(token));
    dispatch(getControlSheetAdvance(token)).then((res) => {
      setSpinner(false);
      setControlSheet(res?.payload?.data);
    });
  }, [dispatch, menuId, token]);


  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'index',
      width: 50,
      render: (text, record, index) => {
        return index + 1;
      },
    },
    {
      title: 'PT #',
      dataIndex: 'ship_header_no',
      key: 'ship_header_no',
      width: 70,
      render: (text, record) => (
        <Link style={{ color: "#0d6efd", textDecoration: "underline" }}
          to={"/order-shipment?mode=edit&order_id=" + record.ship_header_id + "&customer_id/" + record.customer_id + "?edit=yes"}
        >
          {text}
        </Link>
      ),
      ...filterHelper('ship_header_no', 'num')
    },
    {
      title: 'PT Date',
      dataIndex: 'ship_date',
      key: 'ship_date',
      render: (text, record) => {
        return <>{moment(record.ship_date).format("MM-DD-YYYY")}</>;
      },
      width: 90,
      ...filterHelper('ship_date', 'date')
    },
    {
      title: 'Invoice Date',
      dataIndex: 'invoice_date',
      key: 'invoice_date',
      render: (text, record) => {
        return <>{moment(record.invoice_date).format("MM-DD-YYYY")}</>;
      },
      width: 90,
      ...filterHelper('invoice_date', 'date')
    },
    {
      title: 'Start Date',
      dataIndex: 'start_date',
      key: 'start_date',
      render: (text, record) => {
        return <>{moment(record.start_date).format("MM-DD-YYYY")}</>;
      },
      width: 90,
      ...filterHelper('start_date', 'date')
    },
    {
      title: 'Cancel Date',
      dataIndex: 'cancel_date',
      key: 'cancel_date',
      render: (text, record) => {
        return <>{moment(record.cancel_date).format("MM-DD-YYYY")}</>;
      },
      width: 90,
      ...filterHelper('cancel_date', 'date')
    },
    {
      title: 'Due Date',
      dataIndex: 'days_until_net_due',
      render: (_, record) => {
        const dueDate = moment(record.invoice_date).add(record.days_until_net_due, 'days').startOf('day');
        return dueDate.format('MM-DD-YYYY');
      },
      width: 90,
      ...filterHelper('days_until_net_due', 'date')
    },
    {
      title: 'Days Remaining',
      dataIndex: 'days_remaining',
      render: (_, record) => {
        const dueDate = moment(record.invoice_date)
          .add(record.days_until_net_due, 'days')
          .startOf('day');
        const today = moment().startOf('day');
        const diff = dueDate.diff(today, 'days');
        if (diff > 0) {
          return `Due in ${diff} days`;
        } else if (diff === 0) {
          return "Due today";
        } else {
          return (
            <span style={{ color: 'red' }}>
              {`${Math.abs(diff)} days Overdue`}
            </span>
          );
        }
      },
      ...filterHelper('days_remaining', 'date')
    },
    {
      title: 'Customer',
      dataIndex: 'addressee',
      key: 'addressee',
      ...filterHelper('addressee')
    },
    {
      title: 'SO #',
      dataIndex: 'order_header_no',
      key: 'order_header_no',
      ...filterHelper('order_header_no')
    },
    {
      title: 'PO #',
      dataIndex: 'reference_no',
      key: 'reference_no',
      ...filterHelper('reference_no')
    },
    {
      title: 'Qty',
      dataIndex: 'quantity',
      key: 'quantity',
      render: (text, record) => {
        return <>{parseFloat(record.quantity).toFixed(0)}</>;
      },
      align: "right",
      ...filterHelper('quantity', 'num')
    },
    {
      title: 'Amount',
      dataIndex: 'gross_amount',
      key: 'gross_amount',
      render: (text, record) => {
        return <>{currencySymbol}{numeral(record.gross_amount).format("0,00")}</>
      },
      align: "right",
      ...filterHelper('gross_amount', 'num')
    },
    {
      title: 'Discount Amount',
      dataIndex: 'discount_amount',
      key: 'discount_amount',
      render: (text, record) => {
        return <>{currencySymbol}{numeral(record.discount_amount).format("0,00")}</>
      },
      align: "right",
      ...filterHelper('discount_amount', 'num')
    },
    {
      title: 'Freight',
      dataIndex: 'shipping_cost',
      key: 'shipping_cost',
      render: (text, record) => {
        return <>{currencySymbol}{numeral(record.shipping_cost).format("0,00")}</>
      },
      align: "right",
      ...filterHelper('shipping_cost', 'num')
    },
    {
      title: 'Surcharge Amount',
      dataIndex: 'surcharge_amount',
      key: 'surcharge_amount',
      render: (text, record) => {
        return <>{currencySymbol}{numeral(record.surcharge_amount).format("0,00")}</>
      },
      align: "right",
      ...filterHelper('surcharge_amount', 'num')
    },
    {
      title: 'Net Amount',
      dataIndex: 'net_amount',
      key: 'net_amount',
      render: (text, record) => {
        return <>{currencySymbol}{numeral(record.net_amount).format("0,00")}</>
      },
      align: "right",
      ...filterHelper('net_amount', 'num')
    },
    {
      title: 'Term',
      dataIndex: 'term_name',
      key: 'term_name',
      ...filterHelper('term_name')
    },
    {
      title: 'Sale Person',
      dataIndex: 'salesperson_name',
      key: 'salesperson_name',
      ...filterHelper('salesperson_name')
    },
    {
      title: 'Region',
      dataIndex: 'region_name',
      key: 'region_name',
      ...filterHelper('region_name')
    },
    {
      title: 'PT Status',
      dataIndex: 'pt_status_name',
      key: 'pt_status_name',
      ...filterHelper('pt_status_name')
    },
    {
      title: 'Shipped Status',
      dataIndex: 'ship_status_name',
      key: 'ship_status_name',
      ...filterHelper('ship_status_name')
    },
    {
      title: 'Approved',
      dataIndex: 'is_approved',
      key: 'is_approved',
      ...filterHelper('is_approved')
    },
    {
      title: 'Customer Email',
      dataIndex: 'email',
      key: 'email',
      ...filterHelper('email')
    },
    {
      title: 'Customer Phone',
      dataIndex: 'phone',
      key: 'phone',
      ...filterHelper('phone')
    },
    {
      title: 'Comment',
      dataIndex: 'cs_comment',
      key: 'cs_comment',
      ...filterHelper('cs_comment')
    },
    {
      title: '# of Emails Sent',
      dataIndex: 'pt_count',
      key: 'pt_count',
      ...filterHelper('pt_count', 'num')
    },
    {
      title: 'Send Email',
      render: (text, record, index) => {
        const dueDate = moment(record.invoice_date)
          .add(record.days_until_net_due, 'days')
          .startOf('day');
        const today = moment().startOf('day');
        const diff = dueDate.diff(today, 'days'); // yehi days remaining nikalega

        return (
          <Button
            icon={<MailOutlined />}
            loading={loadings[index]}
            disabled={diff < 0} // agar overdue hai toh disable
            onClick={() => sendingEmail(record, index)}
          >
            Send Email
          </Button>
        );
      },
    },
  ];

  function sendingEmail(e, index) {
    setLoadings((prevLoadings) => {
      const newLoadings = [...prevLoadings];
      newLoadings[index] = true;
      return newLoadings;
    });

    const data = {
      ship_date: e.ship_date,
      invoice_date: e.invoice_date,
      cancel_date: e.cancel_date,
      addressee: e.addressee,
      order_header_no: e.order_header_no,
      reference_no: e.reference_no,
      quantity: e.quantity,
      gross_amount: e.gross_amount,
      net_amount: e.net_amount,
      surcharge_amount: e.surcharge_amount,
      term_name: e.term_name,
      salesperson_name: e.salesperson_name,
      salesperson_email: e.salesperson_email,
      region_name: e.region_name,
      pt_status_name: e.pt_status_name,
      is_approved: e.is_approved,
      phone: e.phone,
      is_email: true,
      customer_id: e.customer_id,
      email: e.email,
      cs_comment: e.cs_comment,
      ship_header_id: e.ship_header_id,
      ship_header_no: e.ship_header_no,
      shipping_cost: e.shipping_cost,
      secondary_email: e.secondary_email,
      days_until_net_due: e.days_until_net_due,
      start_date: e.start_date
    }
    if (e.email) {
      // Approved
      dispatch(sendOrderPaymentDuePTEmail(token, data)).then((res) => {
        if (res.type === "SEND_EMAIL_SUCCESS") {
          console.log("REs", res)
          setLoadings((prevLoadings) => {
            const newLoadings = [...prevLoadings];
            newLoadings[index] = false;
            return newLoadings;
          });
          notification.success({
            message: "Success",
            description: res?.payload,
          });
        }
      });
    }
    else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Customer Email is required!"
      });
      setLoadings((prevLoadings) => {
        const newLoadings = [...prevLoadings];
        newLoadings[index] = false;
        return newLoadings;
      });
    }
  }

  return (
    <div className="styleContainer">
      <div className="styleBody h-100">
        <PageHeader
          title={"Control Sheet Advanceship"}
          minimize={setMinimize}
          check={minimize}
        />
      </div>
      <div style={{ marginTop: 10 }}>
        <Table
          title={() =>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <DownloadTableExcel
                filename={`Control-Sheet-Advanceship-${moment().format("MM-DD-YYYY")}`}
                sheet="Control Sheet"
                currentTableRef={tableRef.current}
              >
                <span
                  className="print_icon printing_class">
                  <input
                    style={{ height: "30px", width: "30px" }}
                    size={"large"}
                    type="image"
                    name="ImgExcel"
                    alt="Export to excel"
                    id="ImgExcel"
                    title="Export to excel"
                    src={xlsx}
                  />
                </span>
              </DownloadTableExcel>
            </div>
          }
          ref={tableRef}
          size="small"
          bordered={false}
          type="company"
          scroll={{
            x: 'max-content',
          }}
          pagination={{ pageSize: 1000 }}
          dataSource={controlSheet}
          columns={columns}
          loading={spinner}
          paginate
          rowClassName={(record) => record.is_email ? "odd" : ''}
        />
      </div>
    </div>
  )
}

export default ControlSheetAdvanceShip;